var _path, _a;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5654 4.88672C13.5068 6.17578 12.6279 7.9043 10.8994 10.1309C9.1123 12.4453 7.61816 13.6172 6.3584 13.6172C5.59668 13.6172 4.95215 12.9141 4.4248 11.5078C3.39941 7.69922 2.95996 5.50195 2.11035 5.50195C1.99316 5.50195 1.6709 5.70703 1.08496 6.11719L0.469727 5.32617C1.96387 3.97852 3.39941 2.51367 4.30762 2.42578C5.33301 2.33789 5.97754 3.04102 6.21191 4.53516C7.03223 9.83789 7.41309 10.6582 8.93652 8.22656C9.49316 7.37695 9.78613 6.70312 9.84473 6.26367C9.96191 4.91602 8.79004 5.00391 7.96973 5.35547C8.61426 3.24609 9.84473 2.2207 11.6611 2.2793C13.0088 2.30859 13.6533 3.1875 13.5654 4.88672Z",
    fill: "#1AB7EA"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "https://www.figma.com/design/wMbgHkRz2SmeuHAQ8J7z4k?node-id=66-483"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    y: -1.125,
    width: 13.125,
    height: 17.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink4);
export default __webpack_public_path__ + "static/media/Link-4.c0502dfa74a2ce610c560b275470ffcd.svg";
export { ForwardRef as ReactComponent };